import React from 'react';
import { Calendar } from 'lucide-react';
import { getYearsAsNumbers, getLatestYear } from '@/config/years';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';

interface YearSelectorProps {
  value: number;
  onChange: (year: number) => void;
  className?: string;
  showLabel?: boolean;
  /** Ekstra className for dropdown – bruk f.eks. z-[1000] på kart for å vise over Leaflet */
  selectContentClassName?: string;
}

const YearSelector: React.FC<YearSelectorProps> = ({ value, onChange, className = '', showLabel = true, selectContentClassName }) => {
  const years = getYearsAsNumbers().sort((a, b) => b - a);
  const latestYear = getLatestYear();

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      {showLabel && (
        <label htmlFor="year-select" className="text-sm font-medium text-deepCharcoal flex items-center gap-1.5">
          <Calendar className="h-4 w-4 text-slate-600" />
          År:
        </label>
      )}
      <Select value={String(value)} onValueChange={(v) => onChange(parseInt(v, 10))}>
        <SelectTrigger id="year-select" className="w-[100px] bg-white border-slate-200">
          <SelectValue placeholder="Velg år" />
        </SelectTrigger>
        <SelectContent className={selectContentClassName}>
          {years.map((year) => (
            <SelectItem key={year} value={String(year)}>
              {year === latestYear ? `${year} (nyeste)` : year}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};

export default YearSelector;
